/**
 * @generated SignedSource<<cbfe59e4a27433c6a7ca0a27b1401c6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionBinAndBid_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyItNowButton_user">;
  readonly " $fragmentType": "PdpSharedAuctionActionBinAndBid_user";
};
export type PdpSharedAuctionActionBinAndBid_user$key = {
  readonly " $data"?: PdpSharedAuctionActionBinAndBid_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBinAndBid_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBinAndBid_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "043d8b27d51376e76d857c4f4a391fe3";

export default node;
